<template>
  <VDialog
    :model-value="showDialog"
    @update:model-value="$emit('update:showDialog', $event)"
    max-width="500"
    persistent
    :scrim="forceUpdate"
  >
    <VCard>
      <VCardTitle class="d-flex align-center gap-2">
        <VIcon color="primary">mdi-update</VIcon>
        <span>{{ forceUpdate ? 'Update Required' : 'Update Available' }}</span>
      </VCardTitle>

      <VCardText>
        <div class="mb-4">
          <p class="text-body-1 mb-2">
            {{ forceUpdate
              ? 'A critical update is required. Please update now to continue using the application.'
              : 'A new version is available. Update now for the latest features and improvements.'
            }}
          </p>

          <div class="d-flex flex-column gap-2 pa-3 bg-grey-lighten-4 rounded">
            <div class="d-flex justify-space-between">
              <span class="text-caption">Current Version:</span>
              <span class="font-weight-bold">{{ currentVersion }}</span>
            </div>
            <div class="d-flex justify-space-between">
              <span class="text-caption">Latest Version:</span>
              <span class="font-weight-bold text-primary">{{ latestVersion }}</span>
            </div>
            <div class="d-flex justify-space-between">
              <span class="text-caption">Build Date:</span>
              <span class="text-caption">{{ formattedBuildDate }}</span>
            </div>
          </div>
        </div>

        <VAlert
          v-if="forceUpdate"
          type="warning"
          variant="tonal"
          density="compact"
        >
          This is a mandatory update. The app will refresh automatically.
        </VAlert>
      </VCardText>

      <VCardActions>
        <VSpacer />
        <VBtn
          v-if="!forceUpdate"
          variant="text"
          @click="$emit('dismiss')"
        >
          Later
        </VBtn>
        <VBtn
          color="primary"
          variant="flat"
          @click="$emit('update')"
        >
          {{ forceUpdate ? 'Update Now' : 'Update' }}
        </VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  showDialog: boolean
  currentVersion: string
  latestVersion: string
  buildTimestamp: string
  forceUpdate: boolean
}>()

defineEmits<{
  'update:showDialog': [value: boolean]
  update: []
  dismiss: []
}>()

const formattedBuildDate = computed(() => {
  if (!props.buildTimestamp) return 'N/A'
  try {
    return new Date(props.buildTimestamp).toLocaleString()
  } catch {
    return props.buildTimestamp
  }
})
</script>
